// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const KeynoteExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 37 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={0.833252} width={36} height={36} rx={8} fill="#F28D44" />
				<g opacity={0.8}>
					<path
						d="M26.4333 18.9497C26.4333 20.6408 25.9318 22.2939 24.9923 23.7001C24.0529 25.1062 22.7175 26.2021 21.1552 26.8493C19.5929 27.4965 17.8738 27.6658 16.2152 27.3359C14.5567 27.0059 13.0332 26.1916 11.8375 24.9958C10.6418 23.8 9.82744 22.2764 9.49754 20.6178C9.16763 18.9591 9.33695 17.2399 9.98408 15.6775C10.6312 14.1151 11.7271 12.7797 13.1331 11.8402C14.5392 10.9006 16.1922 10.3992 17.8833 10.3992V18.9497H26.4333Z"
						fill="white"
					/>
					<path
						d="M20.7333 8.50103C21.7314 8.50103 22.7196 8.69762 23.6417 9.07958C24.5638 9.46154 25.4016 10.0214 26.1073 10.7271C26.8131 11.4329 27.3729 12.2708 27.7548 13.1929C28.1367 14.115 28.3333 15.1034 28.3333 16.1015L20.7333 16.1015L20.7333 8.50103Z"
						fill="white"
					/>
				</g>
			</Svg>
		);
	}
);
KeynoteExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default KeynoteExtension;
